import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useSessionEntity } from '@context/EntityContext'

import { TicketIcon } from '@ui/icons/Ticket.icon'

import { TickmillCompaniesEnum } from '@utils/companyName.utils'

import { TickmillProductType } from '@model/TickmillProductType'

import { MenuSection } from '../useMenuSections'

export const useRewardsHubMenu = (): MenuSection => {
  const { t } = useTranslation()
  const entity = useSessionEntity()
  const isTMSC = entity === TickmillCompaniesEnum.TICKMILL_SC

  return useMemo(
    () => ({
      id: 'rewards-hub-menu',
      label: t('Tabs.Rewards Hub.Rewards Hub'),
      icon: TicketIcon,
      condition: isTMSC,
      products: [TickmillProductType.CFD],
      path: '/dashboard/rewards-hub/rewards',
    }),
    [t, isTMSC]
  )
}
